<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-start">
  <h4>{{ 'profiles.view.certifications.label' | translate | titlecase }}</h4>
  <a *ngIf="profileModuleFullAccess" (click)="addNewCertification()">{{
    'profiles.view.certifications.add-a-certification' | translate | titlecase
  }}</a>
</div>
<div
  *ngFor="let certification of certifications; last as isLast"
  class="mb-54 mct-flex mct-col mct-justify-between mct-items-stretch"
>
  <div class="mb-12 mct-grid-gt-sm cert-grid-3col mct-grid-lt-md mct-cols-1-1-lt-md mct-auto-rows-min">
    <div class="f-wb mct-col-1-span-2-lt-md">
      {{ certification.CertificationType.Name }}
    </div>
    <div>
      {{ certification.CertificationNumber }}
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch" *ngIf="profileModuleFullAccess">
      <a (click)="deleteCertification(certification.ProfileCertificationTypeID)" class="light-text">{{
        'common.delete' | translate | titlecase
      }}</a>
      &nbsp;&nbsp;•&nbsp;&nbsp;
      <a (click)="editCertification(certification)">{{ 'common.edit' | translate | titlecase }}</a>
    </div>
  </div>
  <div class="mb-20 mct-grid-gt-sm cert-grid-4col mct-grid-lt-md mct-cols-1-1-lt-md mct-auto-rows-min">
    <div class="mct-flex mct-col">
      <span class="light-text">{{ 'profiles.view.certifications.certification-date' | translate | titlecase }}</span>
      {{ certification.CertificationDate | date : 'M/d/yyyy' }}
    </div>
    <div class="mct-flex mct-col">
      <span class="light-text">{{ 'profiles.view.certifications.date-renewed' | translate | titlecase }}</span>
      {{ certification.ReinstatedDate | date : 'M/d/yyyy' }}
    </div>
    <div class="mct-flex mct-col">
      <span *ngIf="certification.Expired" class="red-text f-wb">{{ 'profiles.view.certifications.expired' | translate | titlecase }}</span>
      <span *ngIf="!certification.Expired" class="light-text">{{
        'profiles.view.certifications.expiration-date' | translate | titlecase
      }}</span>
      <span [ngClass]="certification.Expired ? 'red-text' : ''">{{ certification.ExpirationDate | date : 'M/d/yyyy' }}</span>
    </div>
  </div>
  <div class="f-wb" style="font-size: 13px" *ngIf="certification?.CertificationType?.CertificationRequirements?.length > 0">
    {{ 'profiles.view.certifications.required-ceus' | translate }}
  </div>
  <div class="mct-grid-gt-sm cert-grid-3col mct-grid-lt-md mct-cols-1-1-lt-md" gdRows="!">
    <div *ngFor="let requirement of certification.CertificationType.CertificationRequirements; let i = index" class="mt-7">
      <div>{{ requirement.CE_CreditType.CECreditType }}</div>
      <div>{{ requirement.NumberOfUnitsEarned | number : '1.2-2' }} / {{ requirement.NumberOfUnitsRequired | number : '1.2-2' }}</div>
    </div>
  </div>
  <hr [hidden]="isLast" />
</div>
<ng-container #ceus>
  <div class="mb-27 mct-flex mct-row mct-justify-between mct-items-start">
    <h4>{{ 'profiles.view.certifications.ceus' | translate }}</h4>
    <a *ngIf="profileModuleFullAccess" (click)="addNewCeu()">{{ 'profiles.view.certifications.add-a-ceu' | translate }}</a>
  </div>
  <p-table [showGridlines]="true"
    #certificationActivityDataGrid
    *ngIf="certificationActivities?.TotalCount > 0"
    [lazy]="false"
    [value]="certificationActivities.Result"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="mct-hide-lt-md">
        <th [pSortableColumn]="'CE_CreditType.CECreditType'" style="width: 25%">
          {{ 'profiles.view.certifications.ceu-type' | translate }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'CEUs'" style="width: 10%">
          {{ 'profiles.view.certifications.ceus' | translate }}<p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'CertificationActivitySource?.Name'" style="width: 25%">
          {{ 'profiles.view.certifications.source' | translate | titlecase }}<p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ActivityDate'" style="width: 15%">
          {{ 'profiles.view.certifications.date' | translate | titlecase }}<p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ExpirationDate'" style="width: 15%">
          {{ 'profiles.view.certifications.expiration' | translate | titlecase }}<p-sortIcon></p-sortIcon>
        </th>
        <th *ngIf="profileModuleFullAccess" style="width: 15%"></th>
      </tr>
      <tr class="mct-hide-gt-sm">
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-activity>
      <tr class="mct-hide-lt-md">
        <td>{{ activity.CE_CreditType.CECreditType }}</td>
        <td class="t-ar">{{ activity.CEUs | number : '1.2-2' }}</td>
        <td>
          {{
            activity.CertificationActivitySourceID > 0
              ? activity.CertificationActivitySource?.Name
              : ('profiles.view.certifications.events' | translate | titlecase)
          }}{{
            (activity.EventAttendeeID == 0 && activity.EventAttendeeHeaderID == 0) || activity.EventName == undefined
              ? ''
              : '/' + activity.EventName
          }}
        </td>
        <td>{{ activity.ActivityDate | date : 'M/d/yyyy' }}</td>
        <td [ngClass]="activity.Expired ? 'red-text f-wb' : ''">
          {{ activity.CE_CreditType?.AccreditationCycleMonths > 0 ? (activity.ExpirationDate | date : 'M/d/yyyy') : '' }}
        </td>
        <td *ngIf="profileModuleFullAccess">
          <div class="mct-flex mct-justify-between mct-items-stretch">
            <a (click)="deleteCEU(activity.CertificationActivityID)" class="light-text">{{ 'common.delete' | translate | titlecase }}</a>
            •
            <a (click)="editCEU(activity)">{{ 'common.edit' | translate | titlecase }}</a>
          </div>
        </td>
      </tr>
      <tr class="mct-hide-gt-sm">
        <td>
          <div class="mb-12 mct-flex mct-row mct-justify-between mct-items-stretch">
            <div class="f-wb">
              {{ activity.CE_CreditType.CECreditType }}
            </div>
            <div>{{ activity.CEUs | number : '1.2-2' }}</div>
          </div>
          <div class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
            <div class="light-text">{{ 'profiles.view.certifications.source' | translate | titlecase }}</div>
            <div>
              {{
                activity.CertificationActivitySourceID > 0
                  ? activity.CertificationActivitySource?.Name
                  : ('profiles.view.certifications.events' | translate | titlecase)
              }}{{
                (activity.EventAttendeeID == 0 && activity.EventAttendeeHeaderID == 0) || activity.EventName == undefined
                  ? ''
                  : '/' + activity.EventName
              }}
            </div>
          </div>
          <div class="mct-flex mct-row mct-justify-between mct-items-stretch">
            <div class="mct-flex mct-col">
              <div class="light-text">{{ 'profiles.view.certifications.date' | translate | titlecase }}</div>
              <div>{{ activity.ActivityDate | date : 'M/d/yyyy' }}</div>
            </div>
            <div class="mct-flex mct-col">
              <div class="light-text">{{ 'profiles.view.certifications.expiration' | translate | titlecase }}</div>
              <div [ngClass]="activity.ExpirationDate <= today ? 'red-text f-wb' : ''">
                {{ activity.ExpirationDate | date : 'M/d/yyyy' }}
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <wl-paging-controls
    *ngIf="certificationActivities?.TotalCount > 0"
    [pagedResult]="certificationActivities"
    (pagingEvent)="onPagingEvent($event)"
  ></wl-paging-controls>
</ng-container>
<wl-ceu-edit-dialog #ceuEdit [profileId]="profileId"></wl-ceu-edit-dialog>
<wl-certification-edit-dialog #certificationEdit [profileId]="profileId"></wl-certification-edit-dialog>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="cd.onReject()" class="atlas-btn atlas-btn-secondary mr-10">{{ rejectText }}</button>
    <button pButton type="button" (click)="cd.onAccept()" class="atlas-btn atlas-btn-primary">{{ acceptText }}</button>
  </ng-template>
</p-confirmDialog>
